import { IonButton, useIonRouter } from '@ionic/react';
import { FollowChannelButton } from './FollowChannelButton';

interface ChannelActionButtonProps {
  channelId: string;
  viewerIsOwner: boolean;
  viewerIsFollowing: boolean;
}

// The primary action shown in a channel's header: the owner gets an "Editar"
// button that opens EditChannel; everyone else gets the follow/unfollow button.
export const ChannelActionButton = ({
  channelId,
  viewerIsOwner,
  viewerIsFollowing,
}: ChannelActionButtonProps) => {
  const ionRouter = useIonRouter();

  if (viewerIsOwner) {
    return (
      <IonButton
        size="small"
        onClick={() => ionRouter.push(`/app/main/channels/${channelId}/editar`)}
        data-testid="edit-channel-button"
      >
        Editar
      </IonButton>
    );
  }

  return <FollowChannelButton channelId={channelId} viewerIsFollowing={viewerIsFollowing} />;
};
